import * as React from "react";
import { useEffect, useState } from "react";

type Props = Omit<JSX.IntrinsicElements['input'], 'type'> & {
  indeterminate: boolean,
};

export default function IndeterminateCheckbox({ indeterminate, ...props }: Props) {
  const [inputEl, setInputEl] = useState<HTMLInputElement | null>(null);
  useEffect(() => {
    if (inputEl) {
      inputEl.indeterminate = indeterminate;
    }
  }, [inputEl, indeterminate]);
  return <input {...props} type="checkbox" ref={setInputEl} />
}
